import { maskitoDateOptionsGenerator } from '@maskito/kit';

export enum HeaderLanguageEnum {
  ITA = 'it-IT',
}

export const Patterns = Object.freeze({
  EMAIL: /^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/,
  PLATEVEHICLE: /^([a-zA-z]{2})(\d{3})(\d{2})?(\d{3})?([a-zA-z]{2})?$/,
  FISCALCODE:
    /\b^[a-zA-Z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[a-zA-Z][0-9lmnpqrstuvLMNPQRSTUV]{2}[a-zA-Z][0-9lmnpqrstuvLMNPQRSTUV]{3}[a-zA-Z]$\b/,
  ZIPCODE: /\b\d{5}\b/,
  ABI_CAB: /\b\d{4,5}\b|(^$)/,
  PARTNERSHIPNUMBER: /^[a-zA-Z0-9]{1,13}$/,
  PARTNERSHIPNUMBERCUSTOM: /^[a-zA-Z0-9]{1,8}$/,
  POLICYNUMBER: /^([a-zA-z]{3})?(\d{7,10})((-)(\d{1,2}))?$/,
  PLATENUMBER:
    /^(([A-Z]{2}\d{3}[A-Z]{2})|([A-Z]{2}\d{5,6})|([A-Z]{2}\d{1}((\d{0}[A-Z]{1}\d{4})|(\d{1}[A-Z]{1}\d{3})|(\d{2}[A-Z]{1}\d{2})|(\d{3}[A-Z]{1}\d{1})|(\d{4}[A-Z]{1}\d{0})))|(X[A-Z\d]{5}))$/,
  MORTGAGENUMBER: /^[A-Za-z0-9][ A-Za-z0-9\/-]{0,14}[A-Za-z0-9]$/,
  NOTARYNUMBER: /^[A-Za-z0-9][ A-Za-z0-9\/-]{0,14}[A-Za-z0-9]$/,

  DATE: /^([1-9]|0[1-9]|[12][0-9]|3[01])[/]([1-9]|0[1-9]|1[012])[/](19|20)\d\d$/,
  DATEPICKER: 'DD MMMM YYYY',
  DATE_SLASH_DDMMYYYY: 'DD/MM/YYYY',
  DATE_DASH_YYYYMMDD: 'YYYY-MM-DD',
  PHONE_PREFIX: '+39',
  PHONE_NUMBER: /^([+]39)(3)(\d{2})(\d{3})(\d{3,4})$/,
  PHONE: '+390000000000',
  ADDRESS: /^[a-zA-ZA-zÀ-ú/\-'. ]{1,25}$/,
  ALPHABETIC_APOSTROPHE_1_25: /^[a-zA-ZA-zÀ-ú/\-' ]{1,25}$/,
  ALPHABETIC_NUMBERS_SLASH_BLANKSPACE_1_6: /^[\\ 0-9a-zA-ZA-z/-]{1,6}$/,

  PASSWORD:
    /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!-/:-@[-`{-}])|(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])|(?=.*[A-Z])(?=.*[a-z])(?=.*[!-/:-@[-`{-}])|(?=.*[A-Z])(?=.*[0-9])(?=.*[!-/:-@[-`{-}])|(?=.*[a-z])(?=.*[0-9])(?=.*[!-/:-@[-`{-}]))(?!.*\s).{8,}$/,

  LIMIT_NAME: 25,
  LIMIT_SURNAME: 25,
  LIMIT_STREETNUMBER: 6,
  LIMIT_SQUAREMETER: 3,

  MIN_LENGTH_PASSWORD: 8,
  MAX_LENGTH_PASSWORD: 30,
});

export const Masks = Object.freeze({
  PHONE: {
    mask: [
      '+', '3', '9',
      /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/
    ],
  },
  PHONE_MASK_REPLACER: { 0: '[0-9]' },
  DATE: maskitoDateOptionsGenerator({
    mode: 'dd/mm/yyyy',
    separator: '/',
  }),
  ZIPCODE: {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/]
  },
  PARTNERSHIP: '999999999999',
  AMOUNT: 'NNNNNN',
  AMOUNT_MASK_REPLACER: { N: '[0-9]' },
});

export enum HomeTypesEnum {
  FLAT = 'Flat',
  TERRACED = 'Terraced',
  VILLA = 'Villa',
}

export enum HomeRegimesEnum {
  OWNER = 'Owner',
  TENANT = 'Tenant',
}

export enum HomeUsesEnum {
  PERMANENT = 'Permanent',
  HOLIDAY = 'Holiday',
  RENTED = 'Rented',
}

export enum HomeBranchCode {
  AFFITTO_SERENO = 'AffittoSereno',
  SECONDA_CASA = 'SecondaCasa',
  MUTUO_PROTTETO = 'MutuoProtetto',
  CASA_DIGITAL = 'CasaDigital',
}

export enum PolicyParticipantEnum {
  INSURED = 'NamedInsured',
  POLICY_HOLDER = 'Owner_Vrt',
  DRIVER = 'PMIDriver_Vrt',
  ACCOUNT_HOLDER = 'AccountHolder',
}

export enum PolicySectorCodeEnum {
  HOME = 'HomePRHLine',
  AUTO = 'PMILine',
}

export enum PolicyActionEnum {
  EDIT = 'Change',
  RENEW = 'RenewalCancellation',
  CANCEL = 'Cancellation',
}

export enum ModifyPolicyActionEnum {
  EMAIL = 'EmailChange',
  POLICY_HOLDER_ADDRESS = 'HomeAddressChange',
  HOME_DATA = 'InsuredLocationChange',
  HOME_ADDRESS_AND_DATA = 'HomeAndLocationAddressChange',
  ADDITIONAL_DATA = 'OtherDataChange',
}

export enum ModifyPolicyAdditionalDataActionEnum {
  HOME_DATA = 'HomeDataChange',
  POLICY_HOLDER_ADDRESS = 'PolicyHolderAddressChange',
  HOME_ADDRESS = 'HomeAddressChange',
  MORTGAGE = 'MortgageChange',
}

export enum ModifyQuotationActionEnum {
  HOME_DATA = 'HomeDataChange',
  POLICY_DATA = 'PolicyDataChange',
  POLICY_HOLDER_DATA = 'PolicyHolderDataChange',
  ADDITIONAL_DATA = 'AdditionalDataChange',
}

export enum CancelPolicyReasonsEnum {
  THINKING = 'WithdrawalRight',
  AGREEMENT = 'ContractTermination',
  SALE = 'LossOfPossession',
}

export enum ContactMethodEnum {
  HOME = 'home',
  WORK = 'work',
  MOBILE = 'mobile',
  FAX = 'fax',
  MAIL = 'mail',
}

export enum ModifyPolicySkippingStepsEnum {
  ACTIONS = 'Actions',
  SUBACTIONS = 'SubActions',
}

export enum VertiIntegrationActionEnum {
  /** No Premium action */
  Nothing = 'nothing',
  /** Premium difference < -5€ */
  Refund = 'refund',
  /** Premium difference > +5€ */
  Pay = 'pay',
  /** Premium difference +/- 5€ */
  Confirm = 'confirm',
}

export enum VertiIntegrationFlow {
  NewQuotationNotLogged = 'nq_nl',
  NewQuotationLogged = 'nq_l',
  ModifyQuotationData = 'mq_d',
  ModifyQuotationCoverages = 'mq_c',
  ModifyPolicy = 'mp',
  CancelPolicy = 'cp',
  CancelRenewal = 'cr',
  ShortPolicyRenewal = 'pr_s',
  CompletePolicyRenewal = 'pr_c',
}

export enum VertiIntegrationDestinyEnum {
  /**
   * From Q&B
   * * Home
   * * Auto
   */
  PURCHASE_QUOTATION = 'PURCHASE_QUOTATION',
  /**
   * From Q&B
   * * Home
   * * Auto
   */
  RENEW_QUOTATION = 'RENEW_QUOTATION',
  /**
   * From Q&B
   * * Home
   * * Auto -> Car replacement
   */
  MODIFY_POLICY = 'MODIFY_POLICY',
  /**
   * From Q&B
   * * Home
   */
  CANCEL_POLICY = 'CANCEL_POLICY',
  /**
   * From Q&B
   * * Home
   */
  CANCEL_RENEWAL_POLICY = 'CANCEL_RENEWAL_POLICY',
}

export enum ConsentsName {
  COMMERCIAL_COMMUNICATION = 'commercialCommunication',
  MARKET_RESEARCH = 'marketResearch',
  BUSINESS_RESEARCH = 'businessResearch',
  PROFILING = 'profiling',
}
